import React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import './item.css'

export const recordPath = (base_url, id) => `${base_url}/${id}`

const defaultComponent = ({record}) => (
  <div>
    {JSON.stringify(record)}
  </div>
)

const ListItem = ({record, base_url, component = defaultComponent, selected = false, primaryKey}, {router}) => (
  <li
    className={classnames({
      'listItem': true,
      'listItem--clickable': !selected,
      'listItem--selected': selected
    })}
    onClick={e => {
      e.preventDefault()

      return e.target.tagName !== 'A' ?
        router.history.push(recordPath(base_url, primaryKey(record))) :
        null
    }}
  >
    {
      React.createElement(component, {
        record,
        selected,
        path: recordPath(base_url, primaryKey(record))
      })
    }
  </li>
)

ListItem.contextTypes = {
  router: PropTypes.object
}

export default ListItem



// WEBPACK FOOTER //
// ./src/ui/list/views/item.jsx